"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _cache = require("../cache");
var _getPickedFilters = require("../getPickedFilters");
var _separateFiltersAndSortFromUrl = _interopRequireWildcard(require("../separateFiltersAndSortFromUrl"));
var _categoryThemes = _interopRequireDefault(require("../categoryThemes"));
var _rootCategory = require("../rootCategory");
var _removeSlash = _interopRequireDefault(require("../removeSlash"));
var _getLastNumbersFromString = _interopRequireDefault(require("../getLastNumbersFromString"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getPageSize = function getPageSize(theme) {
  return theme === _categoryThemes["default"].CATEGORY || theme === _categoryThemes["default"].MAIN || theme === _categoryThemes["default"].BRAND || theme === null ? global.__appConfig__.categoryPageSizeLargerRange : global.__appConfig__.categoryPageSize;
};
var activeFiltersPro = function activeFiltersPro(category) {
  return category.length > 1 ? category[1] : "";
};
var categoryInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var context, productsAndFiltersFromCategoryFetcher, categoryFetcher, prismicFetcher, _ref$categoryWithPref, categoryWithPrefix, _context$query, category, initialPage, finalCategory, requestPath, activeFiltersString, language, cache, url, urlPrefix, cacheFilePath, _yield$readCacheFile, cacheFileExist, filenameCategoryCache, cachedRequest, _ref3, activeFilters, urlAfterQuestionMark, getPage, sortFilter, page, sortFilterTemporary, productsAndFiltersFromCache, _productsAndFiltersFr, _productsAndFiltersFr2, _yield$categoryFetche, currentCategory, _yield$Promise$all, _yield$Promise$all2, productsAndFilters, prismicCategory, availableFilters, pickedFilters, _getRangeFiltersAndRe, queryRangeFilters, queryFiltersWithRemovedRangeFiltersPart, _sort$, _sort$2, _sortFilter, sort, sortFiltersString, productsAndFiltersWithActiveFilters, result;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            context = _ref.context, productsAndFiltersFromCategoryFetcher = _ref.productsAndFiltersFromCategoryFetcher, categoryFetcher = _ref.categoryFetcher, prismicFetcher = _ref.prismicFetcher, _ref$categoryWithPref = _ref.categoryWithPrefix, categoryWithPrefix = _ref$categoryWithPref === void 0 ? false : _ref$categoryWithPref;
            _context$query = context.query, category = _context$query.category, initialPage = _context$query.p;
            finalCategory = categoryWithPrefix ? (0, _getLastNumbersFromString["default"])(category === null || category === void 0 ? void 0 : category[0]) : category;
            requestPath = (0, _rootCategory.removeRootCategory)(context.query.requestPath);
            activeFiltersString = categoryWithPrefix ? activeFiltersPro(category) : (0, _removeSlash["default"])(context.query.activeFiltersString);
            language = context.language, cache = context.cache;
            url = context.asPath;
            urlPrefix = categoryWithPrefix ? url.includes("/l/") ? "l/" : "c/" : "";
            cacheFilePath = "".concat(language.language, "/cat/");
            _context.next = 11;
            return (0, _cache.readCacheFile)({
              cacheFilePath: cacheFilePath,
              contextRequest: context.req,
              requestPath: url[0] === "/" ? url.substring(1) : url
            });
          case 11:
            _yield$readCacheFile = _context.sent;
            cacheFileExist = _yield$readCacheFile.cacheFileExist;
            filenameCategoryCache = _yield$readCacheFile.filenameCategoryCache;
            cachedRequest = _yield$readCacheFile.cachedRequest;
            if (!cacheFileExist) {
              _context.next = 17;
              break;
            }
            return _context.abrupt("return", _objectSpread(_objectSpread({}, cachedRequest), {}, {
              categories: context.categories,
              cache: cache
            }));
          case 17:
            _ref3 = categoryWithPrefix ? (0, _separateFiltersAndSortFromUrl.separateFiltersAndSortFromUrlPro)(activeFiltersString, url) : (0, _separateFiltersAndSortFromUrl["default"])(activeFiltersString, url), activeFilters = _ref3.activeFilters, urlAfterQuestionMark = _ref3.urlAfterQuestionMark;
            getPage = function getPage(page) {
              if (!page && typeof window !== "undefined") {
                var _window, _window$location$sear, _window2, _window2$location$sea;
                return (_window = window) !== null && _window !== void 0 && _window.location.pathname.includes(requestPath) ? (_window$location$sear = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location$sea = _window2.location.search.match(/p=(\d+)/)) === null || _window2$location$sea === void 0 ? void 0 : _window2$location$sea[1]) !== null && _window$location$sear !== void 0 ? _window$location$sear : 1 : 1;
              }
              return page;
            };
            page = getPage(initialPage);
            sortFilterTemporary = {
              dir: null,
              order: null
            };
            urlAfterQuestionMark === null || urlAfterQuestionMark === void 0 ? void 0 : urlAfterQuestionMark.split("&").map(function (query) {
              if (query.indexOf("dir") > -1) {
                sortFilterTemporary.dir = query;
              } else if (query.indexOf("order") > -1) {
                sortFilterTemporary.order = query;
              } else if (query.indexOf("p=") > -1) {
                var numberPage = parseInt(query === null || query === void 0 ? void 0 : query.slice(2));
                page = numberPage ? numberPage : 1;
                if (!numberPage) {
                  console.log("Problem with pagination in CategoryPage. query: ".concat(query, ", allQueryFilters: ").concat(activeFilters, " ").concat(urlAfterQuestionMark, ", requestPath: ").concat(requestPath, ", category: ").concat(category));
                }
              }
            });
            if (sortFilterTemporary.dir === null || sortFilterTemporary.order === null) {
              sortFilter = null;
            } else {
              sortFilter = sortFilterTemporary.dir + "&" + sortFilterTemporary.order;
            }
            _context.prev = 23;
            productsAndFiltersFromCache = (0, _cache.getResultFromCache)(url, cache);
            if (!productsAndFiltersFromCache) {
              _context.next = 29;
              break;
            }
            return _context.abrupt("return", {
              initialProductsAndFilters: productsAndFiltersFromCache,
              initialCurrentCategory: productsAndFiltersFromCache.currentCategory,
              categories: productsAndFiltersFromCache.categories,
              theme: (_productsAndFiltersFr = productsAndFiltersFromCache.currentCategory) === null || _productsAndFiltersFr === void 0 ? void 0 : _productsAndFiltersFr.theme,
              initialPrismicCategory: productsAndFiltersFromCache.prismicCategory,
              urlPrefix: urlPrefix,
              categoryId: finalCategory,
              language: language,
              requestPath: requestPath,
              pickedFilters: productsAndFiltersFromCache.pickedFilters,
              pageSize: getPageSize((_productsAndFiltersFr2 = productsAndFiltersFromCache.currentCategory) === null || _productsAndFiltersFr2 === void 0 ? void 0 : _productsAndFiltersFr2.theme),
              initialPage: isNaN(page) ? 1 : page,
              cache: cache
            });
          case 29:
            _context.next = 31;
            return categoryFetcher(finalCategory, language);
          case 31:
            _context.t1 = _yield$categoryFetche = _context.sent;
            _context.t0 = _context.t1 !== null;
            if (!_context.t0) {
              _context.next = 35;
              break;
            }
            _context.t0 = _yield$categoryFetche !== void 0;
          case 35:
            if (!_context.t0) {
              _context.next = 39;
              break;
            }
            _context.t2 = _yield$categoryFetche;
            _context.next = 40;
            break;
          case 39:
            _context.t2 = {};
          case 40:
            currentCategory = _context.t2;
            _context.next = 43;
            return Promise.all([productsAndFiltersFromCategoryFetcher(finalCategory, {}, page, getPageSize(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.theme), null, language), prismicFetcher("category", "category-" + finalCategory, language)]);
          case 43:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 2);
            productsAndFilters = _yield$Promise$all2[0];
            prismicCategory = _yield$Promise$all2[1];
            if (!(Object.keys(productsAndFilters).length === 0 && productsAndFilters.constructor === Object)) {
              _context.next = 49;
              break;
            }
            return _context.abrupt("return", {
              error: {
                statusCode: 404
              }
            });
          case 49:
            availableFilters = productsAndFilters.filters === undefined ? [] : productsAndFilters.filters;
            pickedFilters = {};
            if (activeFilters) {
              _getRangeFiltersAndRe = (0, _getPickedFilters.getRangeFiltersAndRest)(availableFilters, activeFilters), queryRangeFilters = _getRangeFiltersAndRe.queryRangeFilters, queryFiltersWithRemovedRangeFiltersPart = _getRangeFiltersAndRe.queryFiltersWithRemovedRangeFiltersPart;
              pickedFilters = (0, _getPickedFilters.getPickedFiltersWithoutRangeFilters)(queryFiltersWithRemovedRangeFiltersPart, availableFilters);
              queryRangeFilters.forEach(function (filterData) {
                pickedFilters[filterData.filterName] = {};
                pickedFilters[filterData.filterName].to = filterData.max;
                pickedFilters[filterData.filterName].from = filterData.min;
                if (filterData.filterName === "capacity") {
                  pickedFilters[filterData.filterName].to *= 1000;
                  pickedFilters[filterData.filterName].from *= 1000;
                }
              });
            }
            if (sortFilter) {
              sort = sortFilter.split("&");
              sortFiltersString = "".concat((_sort$ = sort[1]) === null || _sort$ === void 0 ? void 0 : _sort$.slice(6), "-").concat((_sort$2 = sort[0]) === null || _sort$2 === void 0 ? void 0 : _sort$2.slice(4));
              if ((_sortFilter = sortFilter) !== null && _sortFilter !== void 0 && _sortFilter.includes("undefined")) {
                console.log("Problem with sort. sortFilter: ".concat(sortFilter, ", allQueryFilters: ").concat(activeFilters, " ").concat(urlAfterQuestionMark, ", requestPath: ").concat(requestPath, ", category: ").concat(finalCategory));
              }
              pickedFilters["sort"] = {
                id: sortFiltersString,
                value: sortFiltersString
              };
            }
            productsAndFiltersWithActiveFilters = productsAndFilters;
            if (!(Object.keys(pickedFilters).length > 0)) {
              _context.next = 58;
              break;
            }
            _context.next = 57;
            return productsAndFiltersFromCategoryFetcher(finalCategory, Object.keys(pickedFilters).length > 0 ? pickedFilters : {}, page, getPageSize(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.theme), null, language);
          case 57:
            productsAndFiltersWithActiveFilters = _context.sent;
          case 58:
            currentCategory.theme = (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.theme) || _categoryThemes["default"].CATEGORY;
            result = {
              initialProductsAndFilters: productsAndFiltersWithActiveFilters,
              initialCurrentCategory: currentCategory,
              categories: context.categories,
              theme: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.theme,
              initialPrismicCategory: prismicCategory,
              urlPrefix: urlPrefix,
              categoryId: finalCategory,
              language: language,
              requestPath: requestPath,
              pickedFilters: pickedFilters,
              pageSize: getPageSize(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.theme),
              initialPage: page
            };
            if (!(cacheFileExist === false)) {
              _context.next = 63;
              break;
            }
            _context.next = 63;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: filenameCategoryCache,
              result: result
            });
          case 63:
            (0, _cache.setUrlInCache)(url, _objectSpread(_objectSpread({}, productsAndFiltersWithActiveFilters), {}, {
              currentCategory: currentCategory,
              theme: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.theme,
              prismicCategory: prismicCategory,
              pickedFilters: pickedFilters,
              categories: context.categories
            }), cache);
            return _context.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
              cache: cache
            }));
          case 65:
            _context.next = 71;
            break;
          case 67:
            _context.prev = 67;
            _context.t3 = _context["catch"](23);
            console.error(_context.t3);
            return _context.abrupt("return", _context.t3);
          case 71:
            return _context.abrupt("return", {});
          case 72:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[23, 67]]);
  }));
  return function categoryInitialProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var _default = categoryInitialProps;
exports["default"] = _default;